import React, { memo } from "react";
import ReactDOM from "react-dom"
import FormItemsContainer from "../../../containers/FormItemsContainer";
import KeywordSearcher from "../../pc/KeywordSearcher";
import DateSelector from "../../common/DateSelector";
import PriceSelector from "../../common/PriceSelector";
import RangeActivitySelector from "../../common/RangeActivitySelector";
import { canUseDOM } from '../../../../utils/ssr';
import { handleChangeIds, countHits } from '../../../../utils/checkBoxFunc';
import { AreaSearcher } from "../../pc/AreaForm";
import SfcCheckBox from "../../../../components/SfcCheckBox";
import Accordion from "../../../../components/Accordion";

const Form = () => {
  const { mainSearchItems, subSearchItems } = FormItemsContainer.useContainer();
  const statusItem = subSearchItems.find(cat => cat.name === 'status');

  if (!canUseDOM()){
    return null;
  }

  return ReactDOM.createPortal(
    <>
      <section className='l_childBox m_searchForm'>
        <h4 className="p_boxHeading">条件で絞り込む</h4>
        <KeywordSearcher />
        <AreaSearcher />
        <MainSearcher key={statusItem.title} {...statusItem}/>
        {mainSearchItems.map((cat) => {
          return <MainSearcher key={cat.title} {...cat}/>
        })}
      </section>
      <section className='l_childBox m_searchForm'>
        <h4 className="p_boxHeading">その他の条件で絞り込む</h4>
        {subSearchItems.map((cat) => {
          return <SubSeacher key={cat.title} {...cat}/>
        })}
      </section>
    </>,
    document.getElementById('jsForm')
  );
}

export const MainSearcher = memo(props => {
  return (props.items
    ? <div>
        <h5>{props.title}</h5>
        <CheckBoxList {...props} />
      </div>
    : false
  )
});

export const SubSeacher = memo(props => {
  const list = props.notAccordion ? <NotAccordionList {...props}></NotAccordionList> : <AccordionList {...props}></AccordionList>
  return (
    (props.items || props.title == '活動日程')
    ? list
    : false
  )
});

const AccordionList = ((props) => {
  return (
    <div className='accordionList'>
        <Accordion wholeClickable={true} showToggleBtn={false}>
          <h5 className="jsAccordionClosing anotherList">{props.title}</h5>
          {(() => {
            switch (props.title) {
              case "予算": return <PriceSelector {...props} />;
              case "活動日程": return <DateSelector {...props} />;
              case "期間":
              case "頻度":
                return <RangeActivitySelector {...props} />;
              default: return <CheckBoxList {...props} />;
            }
          })()}
        </Accordion>
      </div>
  )
});

const NotAccordionList = ((props) => {
  var heading = ''
  if(props.title == "予算"){
    heading = 'priceHeading'
  }else if(props.title == "活動日程"){
    heading = 'dateHeading'
  }else if((props.title == "期間") || (props.title == "頻度")) {
    heading = 'rangeActivityHeading'
  }
  return (
    <div className='NotAccordionList'>
      <h5 className={`jsAccordionClosing anotherList ${heading}`}>{props.title}</h5>
      {(() => {
        switch (props.title) {
          case "予算": return <PriceSelector {...props} />;
          case "活動日程": return <DateSelector {...props} />;
          case "期間":
          case "頻度":
            return <RangeActivitySelector {...props} />;
          default: return <CheckBoxList {...props} />;
        }
      })()}
    </div>
  )
});

const CheckBoxList = memo(props => {
  return (
    <div className='accordionContent'>
      <ul className='searchList'>
        {props.items.map((item) => {
          return (
            <li key={`check-${item.value}`}>
              <div className="itemWrap">
                <SfcCheckBox
                  value={item.value}
                  label={`${item.label}(${countHits(props.aggs.buckets, item.value)})`}
                  checked={props.ids.includes(item.value)}
                  onChangeValue={handleChangeIds(props.ids, props.setIds)}
                />
              </div>
            </li>
          )}
        )}
      </ul>
    </div>
  )
});

export default Form;
